import React, { useEffect } from "react";
import ContactUS from "../../components/ContactUs/ContactUs";
import Footer from "../../components/Footer/Footer";
import PageTop from "../../components/PageTop/PageTop";
import MainNav from "../../shared/MainNav/MainNav";

export default function Contact() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return (
    <>
      <MainNav title="Contact Us" />
      <PageTop pageTitle="Contact Us" />
      <ContactUS />
      <Footer />
    </>
  );
}
